import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  navBarRequired = true;

  constructor(private location: Location,
              private router: Router,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      this.navBarRequired =  this.location.path().indexOf('login') < 0;
    });
  }

  logOut() {
    this.authService.logout();
    this.router.navigate(['auth', 'login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/navbar/navbar.component.ts